import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetElevenlabsUsageDailyV1Query } from './get-elevenlabs-usage-daily-v1-request';
import type { IGetElevenlabsUsageDailyV1Response } from './get-elevenlabs-usage-daily-v1-response';
import { getElevenlabsUsageDailyV1ResponseSchema } from './get-elevenlabs-usage-daily-v1-response';

export async function getElevenlabsUsageDailyV1Api(
  query: IGetElevenlabsUsageDailyV1Query = {},
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetElevenlabsUsageDailyV1Response>> {
  const params = new URLSearchParams();
  if (query.days != null) {
    params.set('days', String(query.days));
  }
  const qs = params.toString();
  return getRequest<IGetElevenlabsUsageDailyV1Response>({
    path: `/sys/elevenlabs/v1/usage-daily${qs ? `?${qs}` : ''}`,
    schema: getElevenlabsUsageDailyV1ResponseSchema,
    options,
  });
}
